import { useEffect, useState } from "react";
import { IMultiCheckBoxInputTable } from "../MultiCheckBoxInputTable.interfaces";
import { MULTI_CHECKBOX_INPUT_ALIGN_TYPES } from "../constants/MultiCheckBoxInputTable.constants";
import { checkIsArrayEmpty } from "@my-scoot/exly-react-component-lib";

export const useMultiCheckBoxInput = <T extends Record<string, any>>({
  multiQuestions,
  onChange,
}: {
  multiQuestions: IMultiCheckBoxInputTable.IMultiTableInputProps<T>["multiQuestions"];
  onChange: IMultiCheckBoxInputTable.IMultiTableInputProps<T>["onChange"];
}) => {
  const [rows, setRows] = useState<T[]>([]);

  /* sync initial data */
  useEffect(() => {
    if (!checkIsArrayEmpty(multiQuestions)) {
      setRows(multiQuestions);
    }
  }, [multiQuestions]);

  const handleCheckboxToggle = (
    rowIndex: number,
    key: IMultiCheckBoxInputTable.IBooleanKeys<T>
  ) => {
    setRows((prev) => {
      const updated = [...prev];
      const row = { ...updated[rowIndex] };

      row[key] = !row[key] as T[typeof key];
      updated[rowIndex] = row;

      onChange?.(updated, row, key);
      return updated;
    });
  };

  const getAlignClass = (align?: string) => {
    if (align === MULTI_CHECKBOX_INPUT_ALIGN_TYPES.LEFT)
      return "tw-text-left !tw-pl-4";
    if (align === MULTI_CHECKBOX_INPUT_ALIGN_TYPES.CENTER)
      return "tw-text-center";
    if (align === MULTI_CHECKBOX_INPUT_ALIGN_TYPES.RIGHT)
      return "tw-text-right";
    return "tw-text-left !tw-pl-4";
  };

  return {
    getAlignClass,
    handleCheckboxToggle,
    rows,
    setRows,
  };
};
